import * as Types from '../../../gen/types';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from '@vue/composition-api';
export type ReactiveFunction<TParam> = () => TParam;
export type PurchasePlanMutationVariables = Types.Exact<{
  accessToken: Types.Scalars['String'];
  cardToken: Types.Scalars['String'];
}>;


export type PurchasePlanMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'purchasePlan'>
);


export const PurchasePlanDocument = gql`
    mutation purchasePlan($accessToken: String!, $cardToken: String!) {
  purchasePlan(accessToken: $accessToken, cardToken: $cardToken)
}
    `;

/**
 * __usePurchasePlanMutation__
 *
 * To run a mutation, you first call `usePurchasePlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePurchasePlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePurchasePlanMutation({
 *   variables: {
 *     accessToken: // value for 'accessToken'
 *     cardToken: // value for 'cardToken'
 *   },
 * });
 */
export function usePurchasePlanMutation(options: VueApolloComposable.UseMutationOptions<PurchasePlanMutation, PurchasePlanMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PurchasePlanMutation, PurchasePlanMutationVariables>>) {
  return VueApolloComposable.useMutation<PurchasePlanMutation, PurchasePlanMutationVariables>(PurchasePlanDocument, options);
}
export type PurchasePlanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PurchasePlanMutation, PurchasePlanMutationVariables>;